 <template>
  <span>
    <v-btn v-on:click.native="calculateDistances()"
           class="google-map"
           color="orange"
           fab
           dark
           small>
      <v-icon dark>access_time</v-icon>
    </v-btn>
    <span> {{distance}} </span>
  </span>
</template>

<script>

export default {
  /* global google */
  name: 'google-map',
  data () {
    return {
      distance: null,
      travelTime: null
    }
  },
  props: ['pickupDate', 'deliveryDate', 'pickupAddresses', 'deliveryAddresses'],
  mounted: function () {
  },
  methods: {
    calculateDistances () {
      var service = new google.maps.DistanceMatrixService()
      service.getDistanceMatrix({
        origins: this.pickupAddresses,
        destinations: this.deliveryAddresses,
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
        drivingOptions: { departureTime: new Date(Date.now()), trafficModel: 'optimistic' },
        avoidHighways: false,
        avoidTolls: false
      }, this.callback)
    },
    callback (response, status) {
      if (status !== google.maps.DistanceMatrixStatus.OK) {
        alert('Error was: ' + status)
      } else {
        var routes = response.rows[0]
        var sortable = []
        var resultText = 'Origin: <b>' + this.pickupAddresses + '</b><br/>'
        resultText += 'Possible Routes: <br/>'
        for (var i = routes.elements.length - 1; i >= 0; i--) {
          var rteLength = routes.elements[i].distance.text
          var rteTime = routes.elements[i].duration.text
          var rteSeconds = routes.elements[i].duration.value
          resultText += 'Route: <b>' + this.deliveryAddresses[i] + '</b>, ' + 'Route Length: <b>' + rteLength + '</b><br/>'
          sortable.push([this.deliveryAddresses[i], rteLength, rteTime, rteSeconds])
        }
        // sort the result lengths from shortest to longest.
        sortable.sort(function (a, b) {
          return a[1] - b[1]
        })
        // build the waypoints.
        var waypoints = []
        for (var j = 0; j < sortable.length - 1; j++) {
          waypoints.push({
            location: sortable[j][0],
            stopover: true
          })
        }
        console.log(resultText)
        this.distance = sortable[0][1]
        this.travelTime = sortable[0][2]
        this.$emit('newDate', sortable)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GoogleMap.vue